import * as React from "react"; // Usa l'importazione namespace
import { useNavigate } from "react-router-dom";

import Select from "react-select";
import { SaveIcon, Search } from "lucide-react";
import config from "./config";
import { getProfileFromToken } from "./config";
import MHeader from "./header";
import { useEffect } from "react";
import Mfooter from "./footer";

function AddAll({ user }) {

  const navigate = useNavigate();

  // --- Guardia per la rotta Admin ---
  React.useEffect(() => {
    let profile = getProfileFromToken();
    if (profile !== "Admin") {
      navigate("/");
    }
  }, [navigate]);

  // --- Stato per i campi del nuovo InfoAll (Allegato) ---
  const [tipo, setTipo] = React.useState('...');
  const [descrizione, setDescrizione] = React.useState('');
  const [url, setUrl] = React.useState('');
  const [file, setSelectedFile] = React.useState('');

  // --- Stato per la Dropdown dei BIMInfo ---
  const [bimInfoList, setBimInfoList] = React.useState([]); // Array di oggetti
  const [selectedBimInfo, setSelectedBimInfo] = React.useState(''); // L'ID scelto
  const [isLoading, setIsLoading] = React.useState(true);

  

  useEffect(() => {
    
     fetch(config.apiUrl+"/biminfo")
      .then((res) => res.json())
      .then((data) => setBimInfoList(data))
      .catch((error) => console.error("Errore nel fetch dei luoghi:", error))
  }, []); // L'array vuoto [] significa "esegui solo al montaggio"

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };
  const handleSetTipo = (value) => {
    if (value==="URL")
    {
      document.getElementById("URL").disabled=false
      document.getElementById("FL").disabled=true
    }
    if  (value==="DOC" || value==="BIM" )
    {
      document.getElementById("URL").disabled=true
      document.getElementById("FL").disabled=false
    }
    setTipo(value);
  };


  // --- Gestione Invio Form ---
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!selectedBimInfo) {
      alert("Per favore, seleziona una Informazione.");
      return;
    }

    const formData = new FormData();
    formData.append('idbiminfo', selectedBimInfo.value); // Associa all'ID del biminfo
    formData.append('tipo', tipo);
    formData.append('descrizione', descrizione);
    formData.append('url', url);
    if (file)
      formData.append('file', file);
    
    try {
      // Assumo un endpoint API '/newinfoall'
      const response = await fetch(config.apiUrl + '/newinfoall', {
        method: 'POST',
        headers: {
          "Authorization": "Bearer " + localStorage.getItem("token")
        },
        body: formData,
      });

      if (response.ok) {
        alert(`Allegato (InfoAll) aggiunto con successo!`);
        navigate("/"); // Ritorna alla home
      } else {
        alert('Errore durante il salvataggio allegato.');
      }
    } catch (error) {
      console.error('Errore:', error);
      alert('Si è verificato un errore durante il salvataggio.');
    }
  };

  // Stili
  /*const styles = {
    app: { padding: '20px', maxWidth: '600px', margin: 'auto' },
    form: { display: 'flex', flexDirection: 'column', gap: '15px' },
    inputGroup: { display: 'flex', flexDirection: 'column' },
    label: { marginBottom: '5px', fontWeight: 'bold' },
    input: { padding: '8px', border: '1px solid #ccc', borderRadius: '4px' },
    textarea: { padding: '8px', border: '1px solid #ccc', borderRadius: '4px', minHeight: '80px' },
    button: { padding: '10px 15px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' },
    smallText: { fontSize: '0.9rem', color: '#555' }
  };
*/
  return (
    <div className="App"> 
        <h2  className="App-header">{config.appName}</h2>
      <MHeader />
      <p><small>utente: {user}</small></p>
      
      <h2>Aggiungi Allegato  a Informazione</h2>
      
      <form onSubmit={handleSubmit} >
        
        {/* Selezione Info  */}
        <div>
          <label>Associa alla Informazione:</label><p></p>
          
          
            <Select
            options={bimInfoList}
            value={selectedBimInfo}
            onChange={setSelectedBimInfo}
            placeholder="Seleziona un Info.."
            isClearable
          />
        <Search  size={1} />

          
          
        </div>

        {/* Tipo */}
         <div style={{ border: '1px solid #ccc', padding: '1rem', margin: '1rem 0', borderRadius: '8px' }}>
          <label >Tipo (Uploaded Docs,  URL):</label><p></p>
         {/* <input
            type="text"
            value={tipo}
            onChange={(e) => setTipo(e.target.value)}
          />
          */}
          
            <select
            
            value={tipo}
            onChange={(e) => handleSetTipo(e.target.value)}
            placeholder="Seleziona un tipo.."
            isClearable
          >
            <option value="..."> Scegli tipo
  
            </option>
            <option value="DOC"> Upoload docs
  
            </option>
             <option value="URL"> URL
  
            </option>
             <option value="BIM"> BIM (xkt file)
  
            </option>
            </select>



        {/* Descrizione */}
          <p></p><label>Descrizione Allegato:</label><p></p>
          <textarea
            
            value={descrizione}
            onChange={(e) => setDescrizione(e.target.value)}
          />
       

       
          <p></p><label>URL Allegato:</label><p></p>
          <input
            id="URL"
            type="text" // o 'url'
            value={url}
            onChange={(e) => setUrl(e.target.value)}
          />

          <p></p><label>File da caricare:</label><p></p>
            <input 
                        type="file" 
                        id="FL"
                        onChange={handleFileChange}
                        accept={tipo === "DOC" ? ".pdf" : ".xkt"}
                       
                        />
          
          <p>
          </p><button type="submit" ><SaveIcon className="mr-2" /><br/>Salva Allegato</button>



        </div>
        
      </form>
      <Mfooter/>
    </div>
  );
}
export default AddAll;
